import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import {
  PaymentData,
  PaymentStatData,
  TopSaleData,
  SupplierDashboardData,
  ReturnDashboardData,
  TerminalProfitData,
} from './types'

export const selectPaymentsDashboard = (state: RootState): PaymentData | undefined =>
  state.dashboarcReducer.payments

export const selectPaymentStatDashboard = (state: RootState): PaymentStatData[] =>
  state.dashboarcReducer.paymentStat

export const selectTopsaleDashboard = (state: RootState): TopSaleData | undefined =>
  state.dashboarcReducer.topSale

export const selectSupplierDashboard = (state: RootState): SupplierDashboardData | undefined =>
  state.dashboarcReducer.supplierData

export const selectReturnDashboard = (state: RootState): ReturnDashboardData[] | undefined =>
  state.dashboarcReducer.returnSummaryData

export const selectEventDashboard = (state: RootState): Event => state.dashboarcReducer.event

export const selectOrderDashboardEvent = (state: RootState): Event =>
  state.dashboarcReducer.orderDashboardEvent

export const selectTerminalProfitDashboard = (state: RootState): TerminalProfitData | undefined =>
  state.dashboarcReducer.terminalProfit

export const selectProfitEventDashboard = (state: RootState): Event => state.dashboarcReducer.profitEvent
